module.exports = __webpack_public_path__ + "img/Layer2op.d8bad00b.png";